import { createPortal } from 'react-dom';

function Portal({ children, container = document.body }) {
  return createPortal(children, container);
}

export default Portal;
